import { useEffect, useRef } from "react";
import { mountPaya } from "./paya";

export function PayaChat() {
  useEffect(() => mountPaya("chat"), []);
  return null;
}

export function PayaContact() {
  const target = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (target.current) return mountPaya("contact", target.current);
  }, []);
  return <div ref={target} data-paya-contact="site_pub_790004d20a284c22be8ae3d429e05ffd" />;
}
